{
  "typeToConfirm": "Для подтверждения введите"
}
